import React, { useEffect, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faBuilding, faTrash, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import AdminFormModal from '../shared/AdminFormModal';
import AdminNotice from '../shared/AdminNotice';
import ActionConfirmationModal from '../shared/ActionConfirmationModal';

const EditFloorModal = ({ show, onClose, floor, onFloorUpdated, onFloorDeleted, tableCount = 0 }) => {
  const [name, setName] = useState('');
  const [showConfirmation, setShowConfirmation] = useState(false);

  useEffect(() => {
    if (floor) {
      setName(floor.name);
    }
  }, [floor]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    await onFloorUpdated({ ...floor, name });
    onClose();
  };

  return (
    <>
      <AdminFormModal
        show={show}
        onClose={onClose}
        title="Katı Düzenle"
        subtitle="Kat adını güncelleyin. Silme işlemi için önce bağlı masaların temizlenmiş olması gerekir."
        icon={faEdit}
        notice={
          tableCount > 0 ? (
            <AdminNotice
              tone="warning"
              title="Silme kısıtı"
              message={`Bu katı silmek için önce bu kattaki ${tableCount} masayı kaldırmalısınız.`}
            />
          ) : null
        }
        footer={(
          <>
            <div className="admin-modal-footer-secondary">
              <Button
                variant="danger"
                onClick={() => setShowConfirmation(true)}
                disabled={tableCount > 0}
                className="modal-save-btn modal-save-btn-danger"
              >
                <FontAwesomeIcon icon={faTrash} />
                Katı Sil
              </Button>
            </div>
            <div className="admin-modal-footer-primary">
              <Button variant="secondary" onClick={onClose} className="modal-cancel-btn">
                İptal
              </Button>
              <Button variant="primary" onClick={handleSubmit} className="modal-save-btn modal-save-btn-success">
                Kaydet
              </Button>
            </div>
          </>
        )}
      >
        <Form onSubmit={handleSubmit} className="admin-form-section">
          <div className="admin-form-block">
            <div className="admin-form-block-title">
              <FontAwesomeIcon icon={faBuilding} />
              Kat Bilgisi
            </div>
            <div className="admin-modal-field">
              <Form.Label>Kat Adı</Form.Label>
              <Form.Control type="text" value={name} onChange={(event) => setName(event.target.value)} className="form-input" required />
            </div>
          </div>
        </Form>
      </AdminFormModal>

      <ActionConfirmationModal
        show={showConfirmation}
        onClose={() => setShowConfirmation(false)}
        onConfirm={() => {
          onFloorDeleted(floor.id);
          setShowConfirmation(false);
          onClose();
        }}
        title="Katı Sil"
        message="Bu katı silmek istediğinizden emin misiniz?"
        consequences={['Kat kaydı tamamen silinecek.', 'Bu işlem geri alınamaz.']}
        confirmLabel="Katı Sil"
        cancelLabel="Vazgeç"
        tone="danger"
        icon={faExclamationTriangle}
      />
    </>
  );
};

export default EditFloorModal;
